"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-3e08ab55"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "collection-list" };
const _hoisted_2 = { class: "collection-list-title" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_1.createElementVNode)("p", null, "调解信息", -1));
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_a_button = (0, vue_1.resolveComponent)("a-button");
    const _component_ListView = (0, vue_1.resolveComponent)("ListView");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            _hoisted_3,
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.createVNode)(_component_a_button, {
                    type: "primary",
                    onClick: _ctx.onBuild
                }, {
                    default: (0, vue_1.withCtx)(() => [
                        (0, vue_1.createTextVNode)("新增")
                    ]),
                    _: 1
                }, 8, ["onClick"])
            ], 512), [
                [vue_1.vShow, !_ctx.unOperate && _ctx.overdueRecord]
            ])
        ]),
        (0, vue_1.createVNode)(_component_ListView, {
            ref: "list-view",
            "complex-list": _ctx.mainData,
            option: _ctx.listOption
        }, null, 8, ["complex-list", "option"])
    ]));
}
exports.render = render;
